import Cookies from 'js-cookie';

export const getCookie = (cookieName: string) => Cookies.get(cookieName);

export const setCookie = (cookieName: string, value: string) => Cookies.set(cookieName, value);

export const removeCookie = (cookieName: string) => Cookies.remove(cookieName);
